import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";

import PostFindItLocal from "./PostFindItLocal";
import FindItLocalList from "./FindItLocalList";
import PostMyLocalNeed from "./PostMyLocalNeed";
import FindItLocalNeedList from "./FindItLocalNeedList";
import FILFlywheel from "./help/FILFlywheel";

export default function FindItLocalHome() {
    const authState = useSelector((state) => state.authReducer);
    const navigate = useNavigate();

    const userId = authState?.user?._id || null;
    const userCode = authState?.user?.think5whyscode || "";
    const userName = authState?.user?.name || "User";

    const [mode, setMode] = useState({
        view: "LIST",     // LIST | POST | NEED | FINDNEED
        category: "ALL"
    });

    const categories = [
        ["ALL", "All", "fa-globe"],
        ["Home Food", "Food", "fa-utensils"],
        ["Regional", "Regional", "fa-location-dot"],
        ["Fresh Today", "Fresh", "fa-leaf"],
        ["Study", "Study", "fa-book"],
        ["Gen Z", "Gen Z", "fa-bolt"],
        ["Gen Alpha", "Gen Alpha", "fa-child"],
        ["Local Deals", "Deals", "fa-tags"],
        // ["Streak Offers", "Streaks", "fa-bolt"],
    ];

    const renderContent = () => {
        if(mode.view === "NABORA") {
            navigate("/nabora");
        } 
        if(mode.view === "VOCALFORLOCAL") {
            navigate("/vocalforlocal");
        }
        switch (mode.view) {
            case "POST":
                return (
                    <PostFindItLocal
                        userId={userId}
                        userCode={userCode}
                        userName={userName}
                    />
                );
            case "LOCALLIST":
                return <FindItLocalList category={mode.category} />;

            case "NEED":
                return <PostMyLocalNeed userId={userId} />;

            case "FINDNEED":
                return <FindItLocalNeedList />;

            case "FLYWHEEL":
                return <FILFlywheel />;

            default:
                return <FILFlywheel />;
        }
    };

    return (
        <div className="min-h-screen bg-[#0b0f19] text-white flex flex-col">
            <div className="sticky top-0 z-10 bg-[#111827] border-b border-gray-800 px-3 py-3">
                <div className="text-cyan-400 font-bold text-xs lg:text-sm">
                    💼 FindItLocal
                </div>
                <div className="text-[10px] text-gray-400">
                    {userName} • {userCode}
                </div>
            </div>

            {/* CATEGORY TABS */}
            <div className="px-4 py-2 grid grid-cols-4 lg:grid-cols-8 bg-[#111827] border-t-2 border-cyan-200 rounded-2xl gap-0.5">
                {categories.map(([id, label, icon]) => (
                    <button
                        key={id}
                        onClick={() =>
                            setMode((prev) => ({
                                ...prev,
                                view: "LOCALLIST",
                                category: id
                            }))
                        }
                        className={`flex flex-col items-center justify-center leading-none px-1 py-0.5 w-fit 
                            ${mode.category === id ? "text-cyan-200" : "text-gray-200"}
                        `}
                    >
                        <i className={`fa ${icon} text-[13px] mb-[2px]`} />
                        <span className="text-[11px] lg:text-sm leading-none">{label}</span>
                    </button>
                ))}
            </div>

            {/* ACTION BAR */}
            <div className="flex flex-wrap gap-2 px-2 py-1 bg-[#0f172a] border-t-1 border-gray-700 rounded-xl mt-2">
                <button
                    onClick={() =>
                        setMode((prev) => ({ ...prev, view: "LOCALLIST" }))
                    }
                    className="px-2 py-1 w-fit rounded-lg bg-cyan-600 text-black text-[11px] lg:text-xs font-bold"
                >
                    ➕ Local Listing
                </button>

                <button
                    onClick={() =>
                        setMode((prev) => ({ ...prev, view: "FINDNEED" }))
                    }
                    className="px-2 py-1 w-fit rounded-lg bg-purple-500 text-black text-[11px] lg:text-xs font-bold"
                >
                    🔍 Find Needs
                </button>

                <button
                    onClick={() =>
                        setMode((prev) => ({ ...prev, view: "NEED" }))
                    }
                    className="px-2 py-1 w-fit rounded-lg bg-yellow-500 text-black text-[11px] lg:text-xs font-bold"
                >
                    🙋 Post Need
                </button>                

                <button
                    onClick={() =>
                        setMode((prev) => ({ ...prev, view: "POST" }))
                    }
                    className="px-2 py-1 w-fit rounded-lg bg-cyan-600 text-black text-[11px] lg:text-xs font-bold"
                >
                    ➕ Post to List
                </button>

                 <button
                    onClick={() =>
                        setMode((prev) => ({ ...prev, view: "NABORA" }))
                    }
                    className="px-2 py-1 w-fit rounded-lg bg-blue-700 text-white text-[11px] lg:text-xs font-bold"
                >
                    🥫 NABORA
                </button>

                <button
                    onClick={() =>
                        setMode((prev) => ({ ...prev, view: "VOCALFORLOCAL" }))
                    }
                    className="px-2 py-1 w-fit rounded-lg bg-blue-700 text-white text-[11px] lg:text-xs font-bold"
                >
                    🫶 VocalForLocal
                </button>

                <button
                    onClick={() =>
                        setMode((prev) => ({ ...prev, view: "FLYWHEEL" }))
                    }
                    className="px-2 py-1 w-fit rounded-lg bg-blue-700 text-white text-[11px] lg:text-xs font-bold"
                >
                    🌀 FlyWheel
                </button>
            </div>

            {/* CONTENT */}
            <div className="flex-1 overflow-y-auto px-3 pb-4">
                {renderContent()}
            </div>
        </div>
    );
}